export const DEFAULT_IMAGE = 'default.png';
export const EDU_COURSE_KEYWORDS_DELIMITER = ',';
export const AT_LEAST_ONE_LANGUAGE_VERSION_MESSAGE =  'Musíte vyplniť aspoň jednu jazykovú verziu.';
export const WRONG_CREDENTIALS_MESSAGE = 'Nesprávne prihlasovacie údaje';
// Mobile max width for responsive design
export const MOBILE_MAX_WIDTH = 768;
// Default countdown of a FRI.via question run (QR code), in minutes
export const QUIZ_QUESTION_DEFAULT_COUNTDOWN_MINUTES = 2;
